import React, { useEffect } from 'react';
import { LoggerModule } from '@vlinder-web/logger-module-react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let renewMarriageExemptionPageMachine: any;

const MODULE_NAME = 'machines.pageContent';
const log: any = LoggerModule?.getInstance();

export const useSMRenewMarriageExemptionPage = (_context: any) => {
  console.log('entered machine');
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  renewMarriageExemptionPageMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(renewMarriageExemptionPageMachine);

  return {
    renewMarriageExemptionPageMachine,
    renewMarriageExemptionPageState: state,
    renewMarriageExemptionPageSend: send,
  };
};
